import { Alert } from '@libs/ui/ds'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import type { FC } from 'react'
import React from 'react'

type Props = {
  isMulti?: boolean
}

const ContractIsntFullyAvailable: FC<Props> = ({ isMulti }) => {
  const { t } = usePlanningFormTranslation()

  return (
    <div data-testid='contract-isnt-fully-available-trick'>
      <Alert intent='semantic.red'>
        {isMulti
          ? t('shiftForm.employeeIsntFullyAvailableMulti')
          : t('shiftForm.employeeIsntFullyAvailableSingle')}
      </Alert>
    </div>
  )
}

export default ContractIsntFullyAvailable
